import React, { Component } from 'react';
import mustache from 'mustache';
import { Liquid } from 'liquidjs';
import { getLiquid } from '../utils/liquid';
import moment from 'moment';

let sampleData = {
    "config":
    {
        "template": "./invoice-template/ro/index.html",
        "tableRowBlock": "./invoice-template/ro/blocks/row.html"
    },
    "data": {
        "currencyBalance": { "main": 1, "secondary": 3.67 },
        "invoice": {
            "number": { "series": "B", "separator": "", "id": 22 },
            "date": "30/01/19", "dueDate": "30/01/19", "explanation": "Thank you for buying from us!", "currency": { "main": "RON", "secondary": "USD" }, 
            "taxes": { "show": true, "vta": "224.20" }, "final": { "hasDiscount": false, "discount": "0.00", "price": "1404.20" }
        },
        "order": {
            "id": 450789469,
            "email": "bob.norman@hostmail.com",
            "closed_at": null,
            "created_at": "2008-01-10T11:00:00-05:00",
            "updated_at": "2008-01-10T11:00:00-05:00",
            "number": 1,
            "note": "Please deliver before noon",
            "token": "b1946ac92492d2347c6235b4d2611184",
            "gateway": "authorize_net",
            "test": false,
            "total_price": "598.94",
            "subtotal_price": "597.00",
            "total_weight": 0,
            "total_tax": "11.94",
            "taxes_included": false,
            "currency": "USD",
            "financial_status": "partially_refunded",
            "confirmed": true,
            "total_discounts": "10.00",
            "total_line_items_price": "597.00",
            "cart_token": "68778783ad298f1c80c3bafcddeea02f",
            "buyer_accepts_marketing": false,
            "name": "#1001",
            "referring_site": "http://www.otherexample.com",
            "landing_site": "http://www.example.com?source=abc",
            "cancelled_at": null,
            "cancel_reason": null,
            "total_price_usd": "598.94",
            "checkout_token": "bd5a8aa1ecd019dd3520ff791ee3a24c",
            "reference": "fhwdgads",
            "user_id": null,
            "location_id": null,
            "source_identifier": "fhwdgads",
            "source_url": null,
            "processed_at": "2008-01-10T11:00:00-05:00",
            "device_id": null,
            "phone": "+557734881234",
            "customer_locale": null,
            "app_id": null,
            "browser_ip": "0.0.0.0",
            "landing_site_ref": "abc",
            "order_number": 1001,
            "discount_applications": [
                {
                    "type": "discount_code",
                    "value": "10.0",
                    "value_type": "percentage",
                    "allocation_method": "across",
                    "target_selection": "all",
                    "target_type": "line_item",
                    "code": "TENOFF"
                }
            ],
            "discount_codes": [
                {
                    "code": "TENOFF",
                    "amount": "10.00",
                    "type": "percentage"
                }
            ],
            "note_attributes": [
                {
                    "name": "custom engraving",
                    "value": "Happy Birthday"
                },
                {
                    "name": "colour",
                    "value": "green"
                }
            ],
            "payment_gateway_names": [
                "bogus"
            ],
            "processing_method": "direct",
            "checkout_id": 901414060,
            "source_name": "web",
            "fulfillment_status": null,
            "tax_lines": [
                {
                    "price": "11.94",
                    "rate": 0.06,
                    "title": "State Tax",
                    "price_set": {
                        "shop_money": {
                            "amount": "11.94",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "11.94",
                            "currency_code": "USD"
                        }
                    }
                }
            ],
            "tags": "",
            "contact_email": "bob.norman@hostmail.com",
            "order_status_url": "https://apple.myshopify.com/690933842/orders/b1946ac92492d2347c6235b4d2611184/authenticate?key=5159a8ea73316ffd79426d0ce3ce0f37",
            "presentment_currency": "USD",
            "total_line_items_price_set": {
                "shop_money": {
                    "amount": "597.00",
                    "currency_code": "USD"
                },
                "presentment_money": {
                    "amount": "597.00",
                    "currency_code": "USD"
                }
            },
            "total_discounts_set": {
                "shop_money": {
                    "amount": "10.00",
                    "currency_code": "USD"
                },
                "presentment_money": {
                    "amount": "10.00",
                    "currency_code": "USD"
                }
            },
            "total_shipping_price_set": {
                "shop_money": {
                    "amount": "0.00",
                    "currency_code": "USD"
                },
                "presentment_money": {
                    "amount": "0.00",
                    "currency_code": "USD"
                }
            },
            "subtotal_price_set": {
                "shop_money": {
                    "amount": "597.00",
                    "currency_code": "USD"
                },
                "presentment_money": {
                    "amount": "597.00",
                    "currency_code": "USD"
                }
            },
            "total_price_set": {
                "shop_money": {
                    "amount": "598.94",
                    "currency_code": "USD"
                },
                "presentment_money": {
                    "amount": "598.94",
                    "currency_code": "USD"
                }
            },
            "total_tax_set": {
                "shop_money": {
                    "amount": "11.94",
                    "currency_code": "USD"
                },
                "presentment_money": {
                    "amount": "11.94",
                    "currency_code": "USD"
                }
            },
            "admin_graphql_api_id": "gid://shopify/Order/450789469",
            "shipping_lines": [
                {
                    "id": 369256396,
                    "title": "Free Shipping",
                    "price": "0.00",
                    "code": "Free Shipping",
                    "source": "shopify",
                    "phone": null,
                    "requested_fulfillment_service_id": null,
                    "delivery_category": null,
                    "carrier_identifier": null,
                    "discounted_price": "0.00",
                    "price_set": {
                        "shop_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        }
                    },
                    "discounted_price_set": {
                        "shop_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        }
                    },
                    "discount_allocations": [],
                    "tax_lines": []
                }
            ],
            "billing_address": {
                "first_name": "Bob",
                "address1": "Chestnut Street 92",
                "phone": "555-625-1199",
                "city": "Louisville",
                "zip": "40202",
                "province": "Kentucky",
                "country": "United States",
                "last_name": "Norman",
                "address2": "",
                "company": null,
                "latitude": 45.41634,
                "longitude": -75.6868,
                "name": "Bob Norman",
                "country_code": "US",
                "province_code": "KY"
            },
            "shipping_address": {
                "first_name": "Bob",
                "address1": "Chestnut Street 92",
                "phone": "555-625-1199",
                "city": "Louisville",
                "zip": "40202",
                "province": "Kentucky",
                "country": "United States",
                "last_name": "Norman",
                "address2": "",
                "company": null,
                "latitude": 45.41634,
                "longitude": -75.6868,
                "name": "Bob Norman",
                "country_code": "US",
                "province_code": "KY"
            },
            "client_details": {
                "browser_ip": "0.0.0.0",
                "accept_language": null,
                "user_agent": null,
                "session_hash": null,
                "browser_width": null,
                "browser_height": null
            },
            "payment_details": {
                "credit_card_bin": null,
                "avs_result_code": null,
                "cvv_result_code": null,
                "credit_card_number": "•••• •••• •••• 4242",
                "credit_card_company": "Visa"
            },
            "customer": {
                "id": 207119551,
                "email": "bob.norman@hostmail.com",
                "accepts_marketing": false,
                "created_at": "2020-02-06T12:51:19-05:00",
                "updated_at": "2020-02-06T12:51:19-05:00",
                "first_name": "Bob",
                "last_name": "Norman",
                "orders_count": 1,
                "state": "disabled",
                "total_spent": "199.65",
                "last_order_id": 450789469,
                "note": null,
                "verified_email": true,
                "multipass_identifier": null,
                "tax_exempt": false,
                "phone": null,
                "tags": "",
                "last_order_name": "#1001",
                "currency": "USD",
                "accepts_marketing_updated_at": "2005-06-12T11:57:11-04:00",
                "marketing_opt_in_level": null,
                "tax_exemptions": [],
                "admin_graphql_api_id": "gid://shopify/Customer/207119551",
                "default_address": {
                    "id": 207119551,
                    "customer_id": 207119551,
                    "first_name": null,
                    "last_name": null,
                    "company": null,
                    "address1": "Chestnut Street 92",
                    "address2": "",
                    "city": "Louisville",
                    "province": "Kentucky",
                    "country": "United States",
                    "zip": "40202",
                    "phone": "555-625-1199",
                    "name": "",
                    "province_code": "KY",
                    "country_code": "US",
                    "country_name": "United States",
                    "default": true
                }
            },
            "line_items": [
                {
                    "id": 466157049,
                    "variant_id": 39072856,
                    "title": "IPod Nano - 8gb",
                    "quantity": 1,
                    "sku": "IPOD2008GREEN",
                    "variant_title": "green",
                    "vendor": null,
                    "fulfillment_service": "manual",
                    "product_id": 632910392,
                    "requires_shipping": true,
                    "taxable": true,
                    "gift_card": false,
                    "name": "IPod Nano - 8gb - green",
                    "variant_inventory_management": "shopify",
                    "properties": [
                        {
                            "name": "Custom Engraving Front",
                            "value": "Happy Birthday"
                        },
                        {
                            "name": "Custom Engraving Back",
                            "value": "Merry Christmas"
                        }
                    ],
                    "product_exists": true,
                    "fulfillable_quantity": 1,
                    "grams": 200,
                    "price": "199.00",
                    "total_discount": "0.00",
                    "fulfillment_status": null,
                    "price_set": {
                        "shop_money": {
                            "amount": "199.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "199.00",
                            "currency_code": "USD"
                        }
                    },
                    "total_discount_set": {
                        "shop_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        }
                    },
                    "discount_allocations": [],
                    "admin_graphql_api_id": "gid://shopify/LineItem/466157049",
                    "tax_lines": [
                        {
                            "title": "State Tax",
                            "price": "3.98",
                            "rate": 0.06,
                            "price_set": {
                                "shop_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                }
                            }
                        }
                    ]
                },
                {
                    "id": 518995019,
                    "variant_id": 49148385,
                    "title": "IPod Nano - 8gb",
                    "quantity": 1,
                    "sku": "SG125F82",
                    "variant_title": "red",
                    "vendor": null,
                    "fulfillment_service": "manual",
                    "product_id": 632910392,
                    "requires_shipping": true,
                    "taxable": true,
                    "gift_card": false,
                    "name": "IPod Nano - 8gb - red",
                    "variant_inventory_management": "shopify",
                    "properties": [],
                    "product_exists": true,
                    "fulfillable_quantity": 1,
                    "grams": 200,
                    "price": "199.00",
                    "total_discount": "0.00",
                    "fulfillment_status": null,
                    "price_set": {
                        "shop_money": {
                            "amount": "199.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "199.00",
                            "currency_code": "USD"
                        }
                    },
                    "total_discount_set": {
                        "shop_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        }
                    },
                    "discount_allocations": [],
                    "admin_graphql_api_id": "gid://shopify/LineItem/518995019",
                    "tax_lines": [
                        {
                            "title": "State Tax",
                            "price": "3.98",
                            "rate": 0.06,
                            "price_set": {
                                "shop_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                }
                            }
                        }
                    ]
                },
                {
                    "id": 703073504,
                    "variant_id": 457924702,
                    "title": "IPod Nano - 8gb",
                    "quantity": 1,
                    "sku": "SG125F85",
                    "variant_title": "black",
                    "vendor": null,
                    "fulfillment_service": "manual",
                    "product_id": 632910392,
                    "requires_shipping": true,
                    "taxable": true,
                    "gift_card": false,
                    "name": "IPod Nano - 8gb - black",
                    "variant_inventory_management": "shopify",
                    "properties": [],
                    "product_exists": true,
                    "fulfillable_quantity": 1,
                    "grams": 200,
                    "price": "199.00",
                    "total_discount": "0.00",
                    "fulfillment_status": null,
                    "price_set": {
                        "shop_money": {
                            "amount": "199.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "199.00",
                            "currency_code": "USD"
                        }
                    },
                    "total_discount_set": {
                        "shop_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        },
                        "presentment_money": {
                            "amount": "0.00",
                            "currency_code": "USD"
                        }
                    },
                    "discount_allocations": [],
                    "admin_graphql_api_id": "gid://shopify/LineItem/703073504",
                    "tax_lines": [
                        {
                            "title": "State Tax",
                            "price": "3.98",
                            "rate": 0.06,
                            "price_set": {
                                "shop_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                }
                            }
                        }
                    ]
                }
            ],
            "fulfillments": [
                {
                    "id": 255858046,
                    "order_id": 450789469,
                    "status": "failure",
                    "created_at": "2020-02-06T12:51:19-05:00",
                    "service": "manual",
                    "updated_at": "2020-02-06T12:51:19-05:00",
                    "tracking_company": "USPS",
                    "shipment_status": null,
                    "location_id": 905684977,
                    "tracking_number": "1Z2345",
                    "tracking_numbers": [
                        "1Z2345"
                    ],
                    "tracking_url": "https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1=1Z2345",
                    "tracking_urls": [
                        "https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1=1Z2345"
                    ],
                    "receipt": {
                        "testcase": true,
                        "authorization": "123456"
                    },
                    "name": "#1001.0",
                    "admin_graphql_api_id": "gid://shopify/Fulfillment/255858046",
                    "line_items": [
                        {
                            "id": 466157049,
                            "variant_id": 39072856,
                            "title": "IPod Nano - 8gb",
                            "quantity": 1,
                            "sku": "SG122F85",
                            "variant_title": "green",
                            "vendor": null,
                            "fulfillment_service": "manual",
                            "product_id": 632910392,
                            "requires_shipping": true,
                            "taxable": true,
                            "gift_card": false,
                            "name": "IPod Nano - 8gb - green",
                            "variant_inventory_management": "shopify",
                            "properties": [
                                {
                                    "name": "Custom Engraving Front",
                                    "value": "Happy Birthday"
                                },
                                {
                                    "name": "Custom Engraving Back",
                                    "value": "Merry Christmas"
                                }
                            ],
                            "product_exists": true,
                            "fulfillable_quantity": 1,
                            "grams": 200,
                            "price": "199.00",
                            "total_discount": "0.00",
                            "fulfillment_status": null,
                            "price_set": {
                                "shop_money": {
                                    "amount": "199.00",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "199.00",
                                    "currency_code": "USD"
                                }
                            },
                            "total_discount_set": {
                                "shop_money": {
                                    "amount": "0.00",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "0.00",
                                    "currency_code": "USD"
                                }
                            },
                            "discount_allocations": [],
                            "admin_graphql_api_id": "gid://shopify/LineItem/466157049",
                            "tax_lines": [
                                {
                                    "title": "State Tax",
                                    "price": "3.98",
                                    "rate": 0.06,
                                    "price_set": {
                                        "shop_money": {
                                            "amount": "3.98",
                                            "currency_code": "USD"
                                        },
                                        "presentment_money": {
                                            "amount": "3.98",
                                            "currency_code": "USD"
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                }
            ],
            "refunds": [
                {
                    "id": 509562969,
                    "order_id": 450789469,
                    "created_at": "2020-02-06T12:51:19-05:00",
                    "note": "it broke during shipping",
                    "user_id": 799407056,
                    "processed_at": "2020-02-06T12:51:19-05:00",
                    "restock": true,
                    "admin_graphql_api_id": "gid://shopify/Refund/509562969",
                    "refund_line_items": [
                        {
                            "id": 104689539,
                            "quantity": 1,
                            "line_item_id": 703073504,
                            "location_id": 487838322,
                            "restock_type": "legacy_restock",
                            "subtotal": 199.0,
                            "total_tax": 3.98,
                            "subtotal_set": {
                                "shop_money": {
                                    "amount": "199.00",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "199.00",
                                    "currency_code": "USD"
                                }
                            },
                            "total_tax_set": {
                                "shop_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                }
                            },
                            "line_item": {
                                "id": 703073504,
                                "variant_id": 457924702,
                                "title": "IPod Nano - 8gb",
                                "quantity": 1,
                                "sku": "SG115F85",
                                "variant_title": "black",
                                "vendor": null,
                                "fulfillment_service": "manual",
                                "product_id": 632910392,
                                "requires_shipping": true,
                                "taxable": true,
                                "gift_card": false,
                                "name": "IPod Nano - 8gb - black",
                                "variant_inventory_management": "shopify",
                                "properties": [],
                                "product_exists": true,
                                "fulfillable_quantity": 1,
                                "grams": 200,
                                "price": "199.00",
                                "total_discount": "0.00",
                                "fulfillment_status": null,
                                "price_set": {
                                    "shop_money": {
                                        "amount": "199.00",
                                        "currency_code": "USD"
                                    },
                                    "presentment_money": {
                                        "amount": "199.00",
                                        "currency_code": "USD"
                                    }
                                },
                                "total_discount_set": {
                                    "shop_money": {
                                        "amount": "0.00",
                                        "currency_code": "USD"
                                    },
                                    "presentment_money": {
                                        "amount": "0.00",
                                        "currency_code": "USD"
                                    }
                                },
                                "discount_allocations": [],
                                "admin_graphql_api_id": "gid://shopify/LineItem/703073504",
                                "tax_lines": [
                                    {
                                        "title": "State Tax",
                                        "price": "3.98",
                                        "rate": 0.06,
                                        "price_set": {
                                            "shop_money": {
                                                "amount": "3.98",
                                                "currency_code": "USD"
                                            },
                                            "presentment_money": {
                                                "amount": "3.98",
                                                "currency_code": "USD"
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            "id": 709875399,
                            "quantity": 1,
                            "line_item_id": 466157049,
                            "location_id": 487838322,
                            "restock_type": "legacy_restock",
                            "subtotal": 199.0,
                            "total_tax": 3.98,
                            "subtotal_set": {
                                "shop_money": {
                                    "amount": "199.00",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "199.00",
                                    "currency_code": "USD"
                                }
                            },
                            "total_tax_set": {
                                "shop_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                },
                                "presentment_money": {
                                    "amount": "3.98",
                                    "currency_code": "USD"
                                }
                            },
                            "line_item": {
                                "id": 466157049,
                                "variant_id": 39072856,
                                "title": "IPod Nano - 8gb",
                                "quantity": 1,
                                "sku": "SG125F88",
                                "variant_title": "green",
                                "vendor": null,
                                "fulfillment_service": "manual",
                                "product_id": 632910392,
                                "requires_shipping": true,
                                "taxable": true,
                                "gift_card": false,
                                "name": "IPod Nano - 8gb - green",
                                "variant_inventory_management": "shopify",
                                "properties": [
                                    {
                                        "name": "Custom Engraving Front",
                                        "value": "Happy Birthday"
                                    },
                                    {
                                        "name": "Custom Engraving Back",
                                        "value": "Merry Christmas"
                                    }
                                ],
                                "product_exists": true,
                                "fulfillable_quantity": 1,
                                "grams": 200,
                                "price": "199.00",
                                "total_discount": "0.00",
                                "fulfillment_status": null,
                                "price_set": {
                                    "shop_money": {
                                        "amount": "199.00",
                                        "currency_code": "USD"
                                    },
                                    "presentment_money": {
                                        "amount": "199.00",
                                        "currency_code": "USD"
                                    }
                                },
                                "total_discount_set": {
                                    "shop_money": {
                                        "amount": "0.00",
                                        "currency_code": "USD"
                                    },
                                    "presentment_money": {
                                        "amount": "0.00",
                                        "currency_code": "USD"
                                    }
                                },
                                "discount_allocations": [],
                                "admin_graphql_api_id": "gid://shopify/LineItem/466157049",
                                "tax_lines": [
                                    {
                                        "title": "State Tax",
                                        "price": "3.98",
                                        "rate": 0.06,
                                        "price_set": {
                                            "shop_money": {
                                                "amount": "3.98",
                                                "currency_code": "USD"
                                            },
                                            "presentment_money": {
                                                "amount": "3.98",
                                                "currency_code": "USD"
                                            }
                                        }
                                    }
                                ]
                            }
                        }
                    ],
                    "transactions": [
                        {
                            "id": 179259969,
                            "order_id": 450789469,
                            "kind": "refund",
                            "gateway": "bogus",
                            "status": "success",
                            "message": null,
                            "created_at": "2005-08-05T12:59:12-04:00",
                            "test": false,
                            "authorization": "authorization-key",
                            "location_id": null,
                            "user_id": null,
                            "parent_id": 801038806,
                            "processed_at": "2005-08-05T12:59:12-04:00",
                            "device_id": null,
                            "receipt": {},
                            "error_code": null,
                            "source_name": "web",
                            "currency_exchange_adjustment": null,
                            "amount": "209.00",
                            "currency": "USD",
                            "admin_graphql_api_id": "gid://shopify/OrderTransaction/179259969"
                        }
                    ],
                    "order_adjustments": []
                }
            ]
        },
        "tasks": [
            {
                "description": "Reactive Seamless Tasty Fresh Keyboard - Granite orange - Steel lavender - qp5-2ex",
                "unit": "Qty", "quantity": 1, "unitPrice": 171, "taxPrice": 32.49, "taxRate": 19, "showVTA": true, "sku" : 23453, "variant": {"hscode": "8471.30"},
                "discountAmount": 15
            },
            {
                "description": "Streamlined Intelligent Metal Soap - Wooden tan - elj-29z", "unit": "Qty",
                "quantity": 2, "unitPrice": 285, "taxPrice": 108.30, "taxRate": 19, "showVTA": true, "sku" : 34453, "variant": {"hscode": "3401.11"},
                "discountAmount": 30
            },
            {
                "description": "Sharable User-friendly Refined Rubber Mouse - Wooden white - Plastic red - w7y-img", "unit": "Qty", "quantity": 1,
                "unitPrice": 76, "taxPrice": 14.44, "taxRate": 19, "showVTA": true, "sku" : 45453, "variant": {"hscode": "8471.60"}
            },
            {
                "description": "Diverse Persevering Tasty Fresh Bike - Cotton plum - knn-vc4", "unit": "Qty",
                "quantity": 3, "unitPrice": 121, "taxPrice": 68.97, "taxRate": 19, "showVTA": true, "sku" : 66453, "variant": {"hscode": "8712.00"},
                "discountAmount": 45
            }]
    },
    "seller": {
        "company": "Invoice Browse",
        "registrationNumber": "US-1222",
        "taxId": "3788999", "address":
        {
            "country": "United States", "region":
                "New York", "city": "New York", "zip": "10001",
            "number": "5th", "street": "Avenue"
        }, "phone": "202-555-0131",
        "email": "contact@growth-connections.com", "website": "www.growth-connections.com", "bank":
            { "$init": true, "iban": "US77LOYD77951232238987", "currency": "USD", "swift": "BA345666", "name": "" },
        "logo": ""
    },
    "buyer": {
        "name": "Karolann Pfeffer", "company": "Acme Industries Ltd.", "notCompany": false,
        "taxId": "US123456789", "registrationNumber": "REG-2024-0042",
        "address":
        {
            "street": "5th Avenue", "country": "United States", "region":
                "New York", "city": "New York", "zip": "10001"
        }, "phone": "202-788-0234",
        "email": "Karolann.Pfeffer@example.com"
    }
}
class ThemePreview extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.locked) {
            return false;
        }

        return true;
    }

    load() {
        let { theme, zoom } = this.props;
        let css = `
            body{
                zoom:${zoom || 0.8};
                background-color:white;
               
                cursor:default;
                overflow-y:scroll;
                overflow-x:hidden;
            }

            [contenteditable="true"], field {
                cursor:pointer;
                min-width:80px;
                display: inline-block;
                background-color: #80808036;
             }

             [contenteditable="true"]:hover, field:hover {
                border-left: 4px solid black;
                border-right: 1px solid white;
                border-bottom:  1px solid white;
                border-right:  1px solid white;
                outline: 2px dotted white;
             }

             [contenteditable="true"]:focus {
                border-left: 4px solid black;
                border-right: 1px solid white;
                border-bottom:  1px solid white;
                border-right:  1px solid white;
                outline: 2px dotted white;
                zoom:2;
                border-radius:4px;
                padding:4px;
             }

             field {
                 cursor: pointer !important;
                 position: relative;
             }

            .actionPanel {
                box-shadow: 1px 1px 4px 0px #8c8b8b;
                padding: 5px;
                width: 180px;
                font-size:18px;
                position: absolute;
                top:0;
                right:-200px;
                background-color: white;
                z-index: 999;
            }

            .btn {
                color: #3f4eae !important;
                background-color: #f9f9f9!important;
                border: 0px solid #3f4eae;
                padding: 2px;
                cursor:pointer;
                text-align: left;
            }

            .btn:hover {
                color: white !important;
                background-color: #3f4eae !important;
                filter: brightness(115%);;
            }
        `
        let body = theme.bodyTemplate;

        const iframe = this.refs.iframe;
        const document = iframe.contentDocument;

        function getRefundsTotal(row){
            let total = 0.0;
            let refunds = row.refunds || [];

            for (let i = 0; i < refunds.length; i++ ){
                let refund = refunds[i];
                let refundLineItems = refund.refund_line_items || [];
                let orderAdjustments = refund.order_adjustments || [];

                for (let j = 0; j < refundLineItems.length; j++){
                    if (row.taxes_included)
                        total+= Number(refundLineItems[j].subtotal);
                    else
                        total+= Number(refundLineItems[j].subtotal) + Number(refundLineItems[j].total_tax);
                }

                for (let k = 0; k < orderAdjustments.length; k++){
                    if (row.taxes_included)
                        total-= Math.abs(Number(orderAdjustments[k].amount));
                    else
                        total-= Math.abs(Number(orderAdjustments[k].amount) + Number(orderAdjustments[k].tax_amount));
                }
            }
            return total;
        }

        const previewTotalPrice = 7030.00;
        const previewRefundedTotal = getRefundsTotal(sampleData.data.order);

        let invoiceData = {
            seller: sampleData.seller
            , buyer: sampleData.buyer
            , description_rows: "",
            order: sampleData.data.order,
            invoice: {
                taxes: {
                    show: true
                },
                currency: {
                    main: "USD",
                    secondary: "USD"
                },
                hasRefunds: !!(sampleData.data.order.refunds && sampleData.data.order.refunds.length > 0),
                final: {
                    price: previewTotalPrice,
                    refunded: previewRefundedTotal,
                    netPayment: previewTotalPrice - previewRefundedTotal
                }
            }
            , total: {
                main: 0
                , secondary: 0
                , taxes: []
                , net: []
                , discount: 0
            }
        };
    
    invoiceData.formatCurrency = function(){
        return  function(dateTmpl, render){
        try{
            let compiled = render(dateTmpl).split(',');

            if (compiled.length < 3 || compiled.length > 4)
                return 'Incorrect formatting syntax';

            let amount = compiled[0].trim().replace(/(\r\n|\n|\r)/gm, "");;
            let lang = compiled[1].trim().replace(/(\r\n|\n|\r)/gm, "");;
            let currency = compiled[2].trim().replace(/(\r\n|\n|\r)/gm, "");;
            let conversionRate = 1;
            if (compiled.length === 4) {
                let rateStr = compiled[3].trim().replace(/(\r\n|\n|\r)/gm, "");
                if (rateStr) conversionRate = Number(rateStr);
            }

            let numberFormat = new Intl.NumberFormat(lang, {style: 'currency', currency: currency });
            return  numberFormat.format(Number(amount) * conversionRate);

        }catch(e){
            console.info(e);
        }

        return 'Incorect formatting syntax';
        }
    }

    invoiceData.abs = function(){
        return function(tmpl, render){
            let rendered = '';
            try {
                rendered = render(tmpl).trim();
                let n = Number(rendered);
                if (Number.isFinite(n)) return String(Math.abs(n));
            } catch (e) {
                console.info(e);
            }
            return rendered;
        }
    }

    invoiceData.formatDate = function(){
        return function(dateTmpl, render){
            try{
                let dateCompiled = render(dateTmpl).split(',');
                let date = dateCompiled[0].trim().replace(/(\r\n|\n|\r)/gm, "");
                let format = dateCompiled[1].trim().replace(/(\r\n|\n|\r)/gm, "");

                if (date && format){
                    return moment(new Date(date.trim())).format(format.trim());
                }
            }catch(e){
                console.info(e);
            }

            return 'Incorect formatting syntax';
        }
    }

        const dp = parseInt(theme.settings && theme.settings.decimalPlaces != null ? theme.settings.decimalPlaces : 2, 10);

        invoiceData.seller = {
            ...invoiceData.seller,
            ...theme,
            decimalPlaces: dp,
            collorPallete: theme.collorPallete
        }

        const rowUsesShowVTA = theme.rowTemplate && theme.rowTemplate.includes('{{#showVTA}}');
        const showVTA = rowUsesShowVTA ? true : (theme.settings && theme.settings.showTaxColumns !== undefined ? theme.settings.showTaxColumns : true);
        invoiceData.showVTA = showVTA;

        for (let i = 0; i < sampleData.data.tasks.length; i++) {
            let cTask = sampleData.data.tasks[i];
            cTask.formatCurrency = invoiceData.formatCurrency;
            cTask.abs = invoiceData.abs;
            cTask.invoice = invoiceData.invoice;
            cTask.nrCrt = i + 1;
            cTask.showVTA = rowUsesShowVTA ? true : showVTA;
            cTask.item = sampleData.data.order.line_items[i+1] || {sku: "SG125F35"}
            cTask.image = cTask.image || { src: 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e2e8f0"/><path d="M12 28l6-8 4 5 6-9 6 12H6z" fill="#94a3b8"/><circle cx="14" cy="16" r="3" fill="#94a3b8"/></svg>') };

            let netPrice = Number(typeof cTask.unitPrice === 'object' ? cTask.unitPrice.main : cTask.unitPrice);
            let rawTaxPrice = Number(cTask.taxPrice || 0);
            let tax = rawTaxPrice / cTask.quantity;

            cTask.unitPrice = {
                main: netPrice.toFixed(dp),
                secondary: netPrice.toFixed(dp),
                gross: (netPrice + tax).toFixed(dp)
            };

            // Build amount object
            let amountMain = netPrice * cTask.quantity;
            let amountGross = amountMain + rawTaxPrice;
            cTask.amount = {
                main: amountMain.toFixed(dp),
                secondary: amountMain.toFixed(dp),
                gross: amountGross.toFixed(dp)
            };

            // Sum the amount to the total
            invoiceData.total.main += amountMain;
            invoiceData.total.secondary += amountMain;

            let taxIdx = invoiceData.total.taxes.findIndex(x => x.rate === cTask.taxRate);
            if (taxIdx === -1) {
                invoiceData.total.taxes.push({ rate: cTask.taxRate, price: rawTaxPrice });
            } else {
                invoiceData.total.taxes[taxIdx].price += rawTaxPrice;
            }
            let netIdx = invoiceData.total.net.findIndex(x => x.rate === cTask.taxRate);
            if (netIdx === -1) {
                invoiceData.total.net.push({ rate: cTask.taxRate, price: amountMain });
            } else {
                invoiceData.total.net[netIdx].price += amountMain;
            }

            cTask.taxPrice = rawTaxPrice.toFixed(dp);
            cTask.unitTaxPrice = tax.toFixed(dp);

            // Mirror the server: when "Merge discounts into product price" is on, the
            // per-line discount folded into the price is exposed on the task, with
            // `original` values reconstructing the pre-discount price/amount.
            let isSummary = !!(theme.settings && theme.settings.mergeDiscounts && theme.settings.showOrderDiscountAsSummary);
            let lineDiscount = (theme.settings && theme.settings.mergeDiscounts) ? Number(cTask.discountAmount || 0) : 0;
            if (isSummary && lineDiscount > 0) {
                // Order-level discount shown as a summary line: display the product at its
                // original price with no strike-through and move the discount to the
                // summary total (total.discount) instead of striking the row.
                let origUnit = netPrice + (cTask.quantity ? lineDiscount / cTask.quantity : 0);
                let origAmount = amountMain + lineDiscount;
                cTask.unitPrice.main = origUnit.toFixed(dp);
                cTask.unitPrice.secondary = origUnit.toFixed(dp);
                cTask.unitPrice.gross = (origUnit + tax).toFixed(dp);
                cTask.amount.main = origAmount.toFixed(dp);
                cTask.amount.secondary = origAmount.toFixed(dp);
                cTask.amount.gross = (origAmount + rawTaxPrice).toFixed(dp);
                cTask.discount = lineDiscount.toFixed(dp);
                cTask.hasDiscount = false;
                invoiceData.total.discount += lineDiscount;
            } else {
                cTask.discount = lineDiscount.toFixed(dp);
                cTask.hasDiscount = lineDiscount > 0;
                cTask.unitPrice.original = (netPrice + (cTask.quantity ? lineDiscount / cTask.quantity : 0)).toFixed(dp);
                cTask.amount.original = (amountMain + lineDiscount).toFixed(dp);
                invoiceData.total.discount += lineDiscount;
            }

            // Render HTML for the current row
            try{
                const engine = getLiquid();
            
                const tpl = engine.parse(theme.rowTemplate);
                invoiceData.description_rows +=  engine.renderSync(tpl, cTask);
            }catch(e){
                try{
                    invoiceData.description_rows += mustache.render(
                        theme.rowTemplate, cTask
                    );
                }catch(e){
                    invoiceData.description_rows += 'Invalid row template!<br/>'
                }
            }
            
        }

        const rawSettings = theme.settings || {};
        const settings = Object.fromEntries(Object.entries(rawSettings).map(([k, v]) => [k, v === '' ? null : v]));
        const sampleDate = moment('2025-01-30');
        const formattedDate = settings.dateFormat ? sampleDate.format(settings.dateFormat) : '30/01/25';
        const formattedDueDate = settings.dateFormat ? moment('2025-02-28').format(settings.dateFormat) : '28/02/25';
        invoiceData.total.taxes.forEach(t => { t.price = Number(t.price).toFixed(dp); });
        invoiceData.total.net.forEach(t => { t.price = Number(t.price).toFixed(dp); });
        invoiceData.total.subtotal = (Number(invoiceData.total.main) + invoiceData.total.discount).toFixed(dp);
        invoiceData.total.hasDiscount = invoiceData.total.discount > 0;
        invoiceData.total.discount = Number(invoiceData.total.discount).toFixed(dp);
        invoiceData.total.main = Number(invoiceData.total.main).toFixed(dp);
        invoiceData.total.secondary = Number(invoiceData.total.secondary).toFixed(dp);
        const finalPrice = Number(sampleData.data.invoice.final.price);
        const invoiceFinal = {...sampleData.data.invoice.final, price: finalPrice.toFixed(dp), discount: Number(sampleData.data.invoice.final.discount || 0).toFixed(dp), refunded: previewRefundedTotal.toFixed(dp), netPayment: (finalPrice - previewRefundedTotal).toFixed(dp)};
        const bodyUsesShowVTA = theme.bodyTemplate && theme.bodyTemplate.includes('{{#invoice.taxes.show}}');
        const taxesShow = bodyUsesShowVTA ? true : showVTA;
        const invoiceTaxes = {...sampleData.data.invoice.taxes, vta: Number(sampleData.data.invoice.taxes.vta || 0).toFixed(dp), show: taxesShow};
        const labels = theme.labels || require('../../config/template_labels').defaultLabels;
        invoiceData = {...invoiceData, ...invoiceData.order, invoice:{...sampleData.data.invoice, hasRefunds: invoiceData.invoice.hasRefunds, date: formattedDate, dueDate: formattedDueDate, final: invoiceFinal, taxes: invoiceTaxes}, settings: settings, labels: labels, decimalPlaces: dp};

        const selectedFont = (settings.font || '').replace(/\s+/g, '+');
        const fontFamilies = `Open+Sans|Libre+Barcode+128|Libre+Barcode+39+Text|Nunito|DM+Sans${selectedFont ? '|' + selectedFont : ''}`;
        const fontOverrides = `<style>${settings.fontSize ? `body { font-size: ${settings.fontSize}px !important; }` : ''}${settings.font ? `body { font-family: ${settings.font} !important; }` : ''}</style>`;
        const fontLink = `<link href="https://fonts.googleapis.com/css?family=${fontFamilies}&display=swap" rel="stylesheet">${fontOverrides}`;
        let final = "";
        try{
            const engine = new Liquid();

            const tpl = engine.parse(body);

            final = engine.renderSync(tpl, invoiceData);
            final = final.replace(/<head>/g, `<head>\n            ${fontLink}`);
        }catch(e){
            try {
                final = mustache.render(body, invoiceData);
                final = final.replace(/<head>/g, `<head>\n            ${fontLink}`);
            } catch (e) {
                final = '<html><body><h4 style="color:red">Error: Invalid template html code. Please check if all tags are closed.</h4></body></html>';
            }
        }
        document.open();
        document.write(final);
        document.close();

       
        
        // Apply settings visibility for templates without Mustache conditionals
        const hasConditionals = body.indexOf('settings.') !== -1;
        if (!hasConditionals) {
            const hide = (el) => { if (el) el.style.display = 'none'; };
            const allElements = document.querySelectorAll('td, div, p, tr, table');
            if (!settings.showShipping) {
                allElements.forEach(el => {
                    const text = el.textContent || '';
                    if ((text.includes('Ship') && text.includes('To')) || (text.includes('Deliver') && text.includes('To'))) {
                        if (el.querySelectorAll('td, div, p').length < 5) hide(el);
                    }
                });
            }
            if (!settings.showBankDetails) {
                allElements.forEach(el => {
                    const text = el.textContent || '';
                    if (text.includes('IBAN') || text.includes('Bank') && text.includes('Account')) {
                        if (el.querySelectorAll('td, div').length < 4) hide(el);
                    }
                });
            }
            if (!settings.showTracking) {
                allElements.forEach(el => {
                    const text = el.textContent || '';
                    if ((text.includes('Track') && (text.includes(':') || text.includes('number'))) || text.includes('Fulfillment')) {
                        if (el.querySelectorAll('td, div').length < 3) hide(el);
                    }
                });
            }
            if (!settings.showNotes) {
                allElements.forEach(el => {
                    const text = el.textContent || '';
                    if (text.includes('Note:') || text.includes('Notes:')) {
                        if (el.querySelectorAll('td, div').length < 3) hide(el);
                    }
                });
            }
        }

        const style = document.createElement('style');
        style.type = 'text/css';
        style.id = 'temp-styles';
        style.appendChild(document.createTextNode(css));
        let existing = document.getElementById('temp-styles');
        if (existing !== null) {
            existing.remove()
        }

        const head = document.getElementsByTagName('head')[0];
        head.appendChild(style);

        
        if (!document.getElementById('template-editor-script')) {
            const script = document.createElement('script');
            script.id = 'template-editor-script';
            script.type = "text/javascript";
            script.src = "/template-editor.js";
            head.appendChild(script);
        }

    }

    componentDidUpdate() {
        this.load();
    }

    componentDidMount() {
        this.load();

    }

    render() {
        let { theme, zoom, height, locked } = this.props;
        let style = {};
        theme.paperSize = theme.paperSize || {
            format: 'A4',
            orientation: 'portrait',
            margin: 0.8
        }
        
        if (height)
            style.height = height;

        return <div style={{ position: 'relative' }}>
           {locked && <div className="template-preview-glass" />}
            <iframe className="template-preview" style={style} ref="iframe" />
            <div style={{
                position: 'absolute',
                bottom: '10px',
                left: '3px'
            }}>
                <label className="label label-success" style={{ marginRight: '2px' }}>{theme.paperSize.format}</label>
                <label className="label label-success">{theme.paperSize.orientation}</label>
            </div>
            <small className="moz-preview-not-available">Preview not avaiable for Firefox. Chrome browser is recommended.</small>
        </div>
    }
}

export default ThemePreview;


// WEBPACK FOOTER //
// app/components/ThemePreview.jsx